<div class="advertisement_payment_timeline">
    <div class="custom_container">
        <div class="container_650">
            <ul class="p-0">
                <!-- start deposit -->
                <li class="d-flex flex-wrap padding_bottom_11" [class.active]="HasUserPaidDeposit">
                    <div class="step_number d-inline-flex justify-content-center align-items-center font_24 font_800 color_black border_solid border_main_color border_r_full margin_end_4">
                        <ng-container *ngIf="!HasUserPaidDeposit; else Completed">
                            1
                        </ng-container>
                        <ng-template #Completed>
                            <i class="fa-solid fa-circle-check"></i>
                        </ng-template>
                    </div>
                    <div class="wrap_content d-inline-block flex-grow-1">
                        <div class="d-flex flex-wrap justify-content-between align-items-center margin_bottom_4">
                            <div class="d-flex align-items-center">
                                <h4 class="mb-0 font_24 font_700 color_black">دفع العربون</h4>
                            </div>
                            <div class="price">
                                <h4 class="mb-0 font_32 font_800 color_main_color">
                                    {{Deposit | currency: ' ' : 'symbol':'1.0'}}<span class="font_20 ms-1">ريال</span>
                                </h4>
                            </div>
                        </div>                    
                        <p class="mb-0 font_20 font_600 color_p_color">الحجز عن طرق دفع رسوم العربون لاثبات جدية الشراء</p>
                    </div>
                </li>
                <!-- end deposit -->
    
                <!-- start price & payments -->
                <li class="padding_bottom_11">
                    <div class="d-flex flex-wrap">
                        <div class="step_number d-inline-flex justify-content-center align-items-center font_24 font_800 color_black border_solid border_main_color border_r_full margin_end_4">
                            2
                        </div>
                        <div class="wrap_content d-inline-block flex-grow-1">
                            <div class="d-flex flex-wrap justify-content-between align-items-center margin_bottom_4">
                                <div class="d-flex align-items-center">
                                    <h4 class="mb-0 font_24 font_700 color_black">المبلغ المطلوب</h4>
                                </div>
                                <div class="price">
                                    <h4 class="mb-0 font_32 font_800 color_main_color">
                                        {{(AdvertisementData | PriceHandler)?.value}}<span class="font_20 ms-1">ريال</span>
                                    </h4>
                                </div>
                            </div>                    
                            <p class="mb-0 font_20 font_600 color_p_color">
                                دفع المبلغ المطلوب على <span class="font_800 color_main_color">{{PaymentCountTitle}}</span> عن طريق سداد
                            </p>
                            <div class="payments margin_top_6">
                                <ng-container *ngFor="let payment of Payments; let index = index; let last = last">
                                    <div class="payment padding_y_4 padding_x_5 border_radius_4" [class.margin_bottom_5]="!last" >
                                        <div class="d-flex flex-wrap justify-content-between align-items-center margin_bottom_4">
                                            <h4 class="mb-0 font_24 font_700 color_black">
                                                <ng-container *ngIf="!last; else LastPayment">
                                                    الدفعة {{InstallmentTitle(index)}} : {{payment.costRatio}}%
                                                </ng-container>
                                                <ng-template #LastPayment>
                                                    الدفعة الأخيرة : {{payment.costRatio}}%
                                                </ng-template>
                                            </h4>
                                            <h4 class="mb-0 font_32 font_800 color_main_color">
                                                {{Price * (payment.costRatio / 100) | currency: ' ' : 'symbol':'1.0'}}<span class="font_20 ms-1">ريال</span>
                                            </h4>
                                        </div>
                                        <p class="mb-0 font_20 font_600 color_p_color">تستحق  في خلال 7 أيام  بعد انجاز {{payment.achievementRatio}}% من المشروع</p>
                                    </div>
                                </ng-container>
                            </div>                        
                        </div>
                    </div>
                </li>
                <!-- end price $ payments -->
    
                <!-- start taxRatio -->
                <li class="d-flex flex-wrap padding_bottom_11">
                    <div class="step_number d-inline-flex justify-content-center align-items-center font_24 font_800 color_black border_solid border_main_color border_r_full margin_end_4">
                        3
                    </div>
                    <div class="wrap_content d-inline-block flex-grow-1">
                        <div class="d-flex flex-wrap justify-content-between align-items-center margin_bottom_4">
                            <div class="d-flex align-items-center">
                                <h4 class="mb-0 font_24 font_700 color_black">ضريبة التصرفات العقارية</h4>
                            </div>
                            <div class="price">
                                <h4 class="mb-0 font_32 font_800 color_main_color">
                                    {{Price * (PaymentPlan?.taxRatio / 100) | currency: ' ' : 'symbol':'1.0'}}<span class="font_20 ms-1">ريال</span>
                                </h4>
                            </div>
                        </div>                    
                        <p class="mb-0 font_20 font_600 color_p_color">ضريبة التصرفات العقارية و هي {{PaymentPlan?.taxRatio}}% من سعر العقار</p>
                    </div>
                </li>
                <!-- end taxRatio -->
    
                <!-- start ownership -->
                <li class="d-flex flex-wrap padding_bottom_11">
                    <div class="step_number d-inline-flex justify-content-center align-items-center font_24 font_800 color_black border_solid border_main_color border_r_full margin_end_4">
                        4
                    </div>
                    <div class="wrap_content d-inline-block flex-grow-1">
                        <div class="d-flex justify-content-between align-items-center margin_bottom_4">
                            <div class="d-flex align-items-center">
                                <h4 class="mb-0 font_24 font_700 color_black">نقل الملكية</h4>
                            </div>
                        </div>                    
                        <p class="mb-0 font_20 font_600 color_p_color">إتمام إجراءات نقل الملكية</p>
                    </div>
                </li>
                <!-- end ownership -->            
                             
            </ul>
            <ng-container *ngIf="(UserInfo | async) && !IsOwner && !HasUserPaidDeposit">
                <div class="text-center marging_top_12">
                    <app-btn (click)="PayNow()" ClassTitle="font_24 font_700" title="احجز الان" />
                </div>
            </ng-container>
        </div>
    </div>
</div>